/*
npm start PARA COMPILAR
npm run build PARA COMPILAR Y MINIFICAR
*/

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0



import React, { FC, useCallback, useEffect, useState } from 'react';
import { getCookie, getUrlVersion, setData, setNotifications, setReturnUrl } from '../commons/functions';
const _preserve = React.version;

import { HomePage } from './subpages/home';
import { Page404 } from './subpages/page404';
import { HomeTabs } from './subpages/tabs';

import { DownloadsBookingsPage } from './subpages/reports/downloads/bookings';
import { DownloadsChecksPage } from './subpages/reports/downloads/checks';
import { DownloadsFlightsPage } from './subpages/reports/downloads/flights';
import { DownloadsMantsPage } from './subpages/reports/downloads/mants';
import { DownloadsMovementsPage } from './subpages/reports/downloads/movements';
import { DownloadsUser } from './subpages/reports/downloads/user';
import { DownloadsUsers } from './subpages/reports/downloads/users';

import { AdminBookingsPage } from './subpages/admin/bookings';
import { AdminUsersPage } from './subpages/admin/users';
import { UserLoginPage } from './subpages/user/login';
import { UserLogoffPage } from './subpages/user/logoff';
import { UserProfilePage } from './subpages/user/profile';
import { UserRestorePage } from './subpages/user/restore';

import { OPSFlightsAdd } from './subpages/ops/flights/add';
import { OPSFlightsInvoice } from './subpages/ops/flights/invoice';
import { OPSFlightsLogs } from './subpages/ops/flights/logs';
import { OPSFlightSearchPage } from './subpages/ops/flights/search';
import { OPSFlightsVouchersListPage } from './subpages/ops/flights/vouchers/list';
import { OPSMercenariesVouchersAddPage } from './subpages/ops/mercenaries/add';


import { AdminRACInvoices } from './subpages/admin/rac/invoices';
import { AdminRACRates } from './subpages/admin/rac/rates';

import { AdminMovementsBankPage } from './subpages/admin/movements/bank';
import { AdminMovementsCasinoPage } from './subpages/admin/movements/casino';
import { AdminMovementsGeneratePage } from './subpages/admin/movements/generate';
import { AdminMovementsHaulmerPage } from './subpages/admin/movements/haulmer';
import { AdminMovementsInstallmentsPage } from './subpages/admin/movements/installments';
import { AdminMovementsPACChargesPage } from './subpages/admin/movements/pac/charges';
import { AdminMovementsPACSubscriptionsPage } from './subpages/admin/movements/pac/subscriptions';
import { AdminMovementsPACUsersPage } from './subpages/admin/movements/pac/users';
import { AdminMovementsReversePage } from './subpages/admin/movements/reverse';
import { AdminMovementsStatementsPage } from './subpages/admin/movements/statements';
import { AdminMovementsTransfersPage } from './subpages/admin/movements/transfers';
import { AdminMovementsUserPage } from './subpages/admin/movements/user';


import { AdminCasinoBookingsPage } from './subpages/admin/casino/bookings';
import { AdminCasinoMovementsPage } from './subpages/admin/casino/movements';
import { AdminCasinoStatementsPage } from './subpages/admin/casino/statements';
import { AdminCasinoStatementsDailyPage } from './subpages/admin/casino/statements.daily';
import { AdminCasinoStatementsMonthlyPage } from './subpages/admin/casino/statements.monthly';



import { MembersAccountsPACPage } from './subpages/members/accounts/payments/pac';
import { MembersAccountsCasinoPage } from './subpages/members/accounts/statements/casino';
import { MembersAccountsClubPage } from './subpages/members/accounts/statements/club';
import { MembersAccountsFuelPage } from './subpages/members/accounts/statements/fuel';

import { MembersAccountsTransferPage } from './subpages/members/accounts/payments/transfers';
import { MembersEtcCalendarPage } from './subpages/members/etc/calendar';
import { MembersEtcCamerasPage } from './subpages/members/etc/cameras';
import { MembersEtcDocsPage } from './subpages/members/etc/docs';
import { MembersEtcDownloads } from './subpages/members/etc/downloads';
import { MembersEtcLogBookPage } from './subpages/members/etc/logbook';
import { MembersEtcPollsPage } from './subpages/members/etc/polls';
import { MembersEtcPollsAnswersPage } from './subpages/members/etc/polls.answers';
import { MembersEtcPollsResultsPage } from './subpages/members/etc/polls.results';
import { MembersEtcShiftsFlightsPage } from './subpages/members/etc/shifts/flights';
import { MembersEtcShiftsPage } from './subpages/members/etc/shifts/list';
import { MembersEtcShiftsRotatePage } from './subpages/members/etc/shifts/rotate';
import { MemnbersEtcTakeNotePage } from './subpages/members/etc/takenote';


import { MembersMercenariesBookPage } from './subpages/members/mercenaries/book';
import { MembersMercenariesPaxPage } from './subpages/members/mercenaries/pax';
import { MembersMercenariesShiftsPage } from './subpages/members/mercenaries/shifts';

import { MembersAccountCasinoPayPage } from './subpages/members/accounts/payments/casinopay';
import { MembersAccountWebPayPage } from './subpages/members/accounts/payments/webpay';


import { MembersBookingsBookPage } from './subpages/members/bookings/book';
import { MembersBookingsGridPage } from './subpages/members/bookings/grid';
import { MembersBookingMyBookingsPage } from './subpages/members/bookings/mybookings';
import { MembersBookingsPlanningPage } from './subpages/members/bookings/planning';
import { MembersBookingsTowingsPage } from './subpages/members/bookings/towings';


import { MembersEDVBioPage } from './subpages/members/edv/bio';
import { MembersEDVRequestChecksPage } from './subpages/members/edv/checkrequest';
import { MembersEDVMyPendingChecksPage } from './subpages/members/edv/checkrequests';
import { MembersEDVMyChecksPage } from './subpages/members/edv/checks';
import { MembersEDVCoursesPage } from './subpages/members/edv/courses';
import { MembersEDVFaiPage } from './subpages/members/edv/fai';
import { MembersEDVFlightLogsPage } from './subpages/members/edv/flightlogs';
import { MembersEtcRiskPage } from './subpages/members/edv/risk';



import { MembersEquipmentsAddNotePage } from './subpages/members/equipments/addnote';
import { MembersEquipmentsNotesPage } from './subpages/members/equipments/notes';
import { MembersEquipmentsSimulatePage } from './subpages/members/equipments/simulate';
import { MembersEquipmentsStatePage } from './subpages/members/equipments/state';





import { AdminProcessesChargesPage } from './subpages/admin/processes/charges';
import { AdminProcessesInstallmentsPage } from './subpages/admin/processes/installments';
import { AdminProcessesPACPage } from './subpages/admin/processes/pac';
import { AdminProcessesSoftLandPage } from './subpages/admin/processes/softland';

import { UserACKPage } from './subpages/user/acks';
import { UserPasswordPage } from './subpages/user/password';
import { UserStudentPage } from './subpages/user/student';


import { EDVAnnotationsPage } from './subpages/edv/annotations';
import { EDVBioPage } from './subpages/edv/bio';
import { EDVCheckMasters } from './subpages/edv/checks/masters';
import { EDVChecksMyChecksPage } from './subpages/edv/checks/mychecks';
import { EDVChecksMyEvalsPage } from './subpages/edv/checks/myevals';
import { EDVChecksPendingPage } from './subpages/edv/checks/pending';
import { EDVChecksSearchPage } from './subpages/edv/checks/search';
import { EDVInstructionFlightLogsPage } from './subpages/edv/instruction/flightlogs';

import { EDVInstructionMyStudentsPage } from './subpages/edv/instruction/mystudents';
import { EDVInstructionStudentsPage } from './subpages/edv/instruction/students';
import { MembersEDVLicencesPage } from './subpages/members/edv/licences';
import { MembersEDVZonesPage } from './subpages/members/edv/zones';


import { OPSFuelInvoicePage } from './subpages/ops/fuel/invoice';
import { OPSFuelMovementsPage } from './subpages/ops/fuel/movements';
import { OPSFuelPrices } from './subpages/ops/fuel/prices';
import { OPSFuelSaleJP1 } from './subpages/ops/fuel/sale';
import { OPSFuelTanksAddMeasurePage } from './subpages/ops/fuel/tanks/addmeasure';
import { OPSFuelTanksFlowsPage } from './subpages/ops/fuel/tanks/flows';
import { OPSFuelTanksLevelsPage } from './subpages/ops/fuel/tanks/levels';
import { OPSFuelTanksMeasurePage } from './subpages/ops/fuel/tanks/measure';
import { OPSMercenariesPAXPage } from './subpages/ops/mercenaries/pax';
import { OPSMercenariesShiftsPage } from './subpages/ops/mercenaries/shifts';
import { OPSPlanningBookPage } from './subpages/ops/planning/book';
import { OPSPlanningBookDeletePage } from './subpages/ops/planning/bookdelete';
import { OPSPlanningBookingsPage } from './subpages/ops/planning/bookings';
import { OPSPlanningUsersPage } from './subpages/ops/planning/members';
import { OPSPlanningShiftsPage } from './subpages/ops/planning/shifts';
import { OPSPlanningTowingsPage } from './subpages/ops/planning/towings';



import { CMAEquipmentsFlightLogsPage } from './subpages/cma/equipments/logs';
import { CMANotesAddPage } from './subpages/cma/notes/add';
import { CMANotesAnswerPage } from './subpages/cma/notes/answer';
import { CMANotesListPage } from './subpages/cma/notes/list';

import { CMAEquipmentsDocumentsPage } from './subpages/cma/equipments/documents';
import { CMAEquipmentsOOFPage } from './subpages/cma/equipments/oof';
import { CMAEquipmentsStatePage } from './subpages/cma/equipments/state';


import { MasterEquipmentsAddPage } from './subpages/masters/equipments/add';
import { MasterEquipmentsCategoriesPage } from './subpages/masters/equipments/categories';
import { MasterEquipmentsEquipmentPage } from './subpages/masters/equipments/equipment';
import { MasterEquipmentsGroupsPage } from './subpages/masters/equipments/groups';
import { MasterEquipmentsRatesPage } from './subpages/masters/equipments/rates';
import { MasterEquipmentsSyncSMPage } from './subpages/masters/equipments/syncsm';
import { MasterShiftsPage } from './subpages/masters/shifts';

import { MasterParametersBlockings } from './subpages/masters/parameters/blockings';
import { MasterParametersHolidays } from './subpages/masters/parameters/holidays';
import { MasterParametersIndicators } from './subpages/masters/parameters/indicators';
import { MastersUserAddPage } from './subpages/masters/user.add';
import { MastersUsersPage } from './subpages/masters/users';


import { MasterAccounts } from './subpages/masters/accounts';
import { MasterCharges } from './subpages/masters/charges';
import { MastersDocsPage } from './subpages/masters/docs';
import { MasterGroups } from './subpages/masters/groups';
import { MasterGroupsUsers } from './subpages/masters/groups.users';
import { MasterHangars } from './subpages/masters/hangars';


import { ReportsFinancesBalancesPage } from './subpages/reports/finances/balances';
import { ReportsFinancesDelinquencyPage } from './subpages/reports/finances/delinquency';
import { ReportsFinancesDueDebtPage } from './subpages/reports/finances/duedebt';
import { ReportsFinancesDuplicatesPage } from './subpages/reports/finances/duplicates';
import { ReportsFinanceInOutPage } from './subpages/reports/finances/finance.inout';
import { ReportsFinanceOutstandingPage } from './subpages/reports/finances/outstanding';
import { ReportsFinancesRXPage } from './subpages/reports/finances/rx';
import { ReportsFinanceTransfersPage } from './subpages/reports/finances/transfers';
import { ReportsFinanceTransfersChargesPage } from './subpages/reports/finances/transfers.charges';
import { ReportsFinancesUsersChargesPage } from './subpages/reports/finances/users.charges';

import { ReportsEDVInstructionPage } from './subpages/reports/edv/instruction';
import { ReportsEDVProgressPage } from './subpages/reports/edv/progress';
import { ReportsEDVRiskPage } from './subpages/reports/edv/risk';
import { ReportsEDVTowingsPage } from './subpages/reports/edv/towings';

import { ReportsOpsFuelConsumption } from './subpages/reports/ops/fuelconsumption';
import { ReportsOpsFuelMovementsPage } from './subpages/reports/ops/fuelmovements';
import { ReportsOpsFuelUsabilityPage } from './subpages/reports/ops/usability';


import { CommCalendarEventsPage } from './subpages/comm/events/calendar';
import { CommMailingsCreatePage } from './subpages/comm/mailings/create';
import { CommMailingsQueuePage } from './subpages/comm/mailings/queue';
import { CommNewsListPage } from './subpages/comm/news/list';
import { CommPollsEditPage } from './subpages/comm/polls/edit';
import { CommPollsEnablePage } from './subpages/comm/polls/enable';
import { CommPollsPage } from './subpages/comm/polls/list';
import { CommPollsRollPage } from './subpages/comm/polls/roll';
import { CommTakeNotesPage } from './subpages/comm/takenotes';


import { Error404 } from '../../components/errors/e404';
import { setCookie } from '../commons/functions';
import { BreadPage } from './subpages/default';
import { SystemCrons } from './subpages/system/crons';
import { SystemEmails } from './subpages/system/emails';
import { SystemLogs } from './subpages/system/logs';
import { SystemRoutingAssignPage } from './subpages/system/routing/assign';
import { SystemRoutingEditPage } from './subpages/system/routing/edit';
import { SystemRoutingIAPage } from './subpages/system/routing/ia';
import { SystemRoutingOrderPage } from './subpages/system/routing/order';
import { Template } from './subpages/system/routing/template';
import { Tester } from './subpages/system/routing/tester';
import { SystemTables } from './subpages/system/tables';

import { IADataQueryPage } from './subpages/ia/data.query';


/*
import { OPSMercenariesPage } from './subpages/ops/mercenaries/default';
import { AdminDownloadsPage } from './subpages/reports/downloads/default';
import { AdminPage } from './subpages/admin/default';
import { AdminRACPage } from './subpages/admin/rac/default';
import { AdminMovementsPage } from './subpages/admin/movements/default';
import { MembersPage } from './subpages/members/default';
import { MembersEquipmentsPage } from './subpages/members/equipments/default';
import { MembersAccountsPage } from './subpages/members/accounts/default';
import { MembersBookingsPage } from './subpages/members/bookings/default';
import { MembersEDVPage } from './subpages/members/edv/default';
import { OPSPage } from './subpages/ops/default';
import { OPSFuelPage } from './subpages/ops/fuel/default';
import { EDVPage } from './subpages/edv/default';
import { EDVChecksPage } from './subpages/edv/checks/default';
import { CMANotesPage } from './subpages/cma/notes/default';
import { CMAEquipmentsPage } from './subpages/cma/equipments/default';
import { MasterEquipmentsPage } from './subpages/masters/equipments/default';
import { MastersParametersPage } from './subpages/masters/parameters/default';
import { ReportsFinancesPage } from './subpages/reports/finances/default';
import { ReportsEDVPage } from './subpages/reports/edv/default';
import { AdminCommMailingsPage } from './subpages/comm/mailings/default';
import { CommNewsPage } from './subpages/comm/news/default';
import { AdminCommPage } from './subpages/comm/default';
import { CommPollsPage } from './subpages/comm/polls/default';
*/

const pages: Record<string, FC> = {

  'user/login': UserLoginPage,
  'user/logoff': UserLogoffPage,
  'user/profile': UserProfilePage,
  'user/restore': UserRestorePage,

  'reports/downloads/movements': DownloadsMovementsPage,
  'reports/downloads/checks': DownloadsChecksPage,
  'reports/downloads/flights': DownloadsFlightsPage,
  'reports/downloads/bookings': DownloadsBookingsPage,
  'reports/downloads/mants': DownloadsMantsPage,
  'reports/downloads/users': DownloadsUsers,
  'reports/downloads/user': DownloadsUser,


  'admin/users': AdminUsersPage,

  'members/edv/default': BreadPage,
  'admin/movements/user': AdminMovementsUserPage,
  'admin/movements/bank': AdminMovementsBankPage,
  'admin/movements/casino': AdminMovementsCasinoPage,
  'admin/movements/transfers': AdminMovementsTransfersPage,
  'admin/movements/installments': AdminMovementsInstallmentsPage,
  'admin/movements/reverse': AdminMovementsReversePage,
  'admin/movements/statements': AdminMovementsStatementsPage,
  'admin/movements/generate': AdminMovementsGeneratePage,
  'admin/movements/haulmer': AdminMovementsHaulmerPage,

  'admin/casino/movements': AdminCasinoMovementsPage,
  'admin/casino/bookings': AdminCasinoBookingsPage,
  'admin/casino/statements': AdminCasinoStatementsPage,
  'admin/casino/statements.daily': AdminCasinoStatementsDailyPage,
  'admin/casino/statements.monthly': AdminCasinoStatementsMonthlyPage,

  'admin/rac/invoices': AdminRACInvoices,
  'admin/rac/rates': AdminRACRates,
  'admin/movements/pac/subscriptions': AdminMovementsPACSubscriptionsPage,
  'admin/movements/pac/charges': AdminMovementsPACChargesPage,
  'admin/movements/pac/users': AdminMovementsPACUsersPage,



  'ops/flights/default': BreadPage,
  'ops/flights/vouchers/default': BreadPage,
  'ops/flights/logs': OPSFlightsLogs,
  'ops/flights/add': OPSFlightsAdd,
  'ops/flights/search': OPSFlightSearchPage,
  'ops/flights/invoice': OPSFlightsInvoice,
  'ops/mercenaries/add': OPSMercenariesVouchersAddPage,
  'ops/flights/vouchers/list': OPSFlightsVouchersListPage,


  'members/accounts/statements/club': MembersAccountsClubPage,
  'members/accounts/statements/fuel': MembersAccountsFuelPage,
  'members/accounts/payments/transfers': MembersAccountsTransferPage,
  'members/accounts/statements/casino': MembersAccountsCasinoPage,
  'members/etc/shifts/list': MembersEtcShiftsPage,
  'members/etc/shifts/rotate': MembersEtcShiftsRotatePage,
  'members/etc/shifts/flights': MembersEtcShiftsFlightsPage,

  'members/etc/logbook': MembersEtcLogBookPage,
  'members/etc/takenote': MemnbersEtcTakeNotePage,
  'members/etc/cameras': MembersEtcCamerasPage,
  'members/etc/downloads': MembersEtcDownloads,
  'members/etc/calendar': MembersEtcCalendarPage,

  'members/etc/polls': MembersEtcPollsPage,
  'members/etc/polls.answers': MembersEtcPollsAnswersPage,
  'members/etc/polls.results': MembersEtcPollsResultsPage,
  'members/etc/docs': MembersEtcDocsPage,
  'members/mercenaries/shifts': MembersMercenariesShiftsPage,
  'members/mercenaries/pax': MembersMercenariesPaxPage,
  'members/mercenaries/book': MembersMercenariesBookPage,
  'members/accounts/payments/webpay': MembersAccountWebPayPage,
  'members/accounts/payments/casinopay': MembersAccountCasinoPayPage,
  'members/accounts/payments/pac': MembersAccountsPACPage,

  'members/bookings/mybookings': MembersBookingMyBookingsPage,
  'members/bookings/towings': MembersBookingsTowingsPage,
  'members/bookings/grid': MembersBookingsGridPage,
  'members/bookings/planning': MembersBookingsPlanningPage,
  'members/bookings/book': MembersBookingsBookPage,
  'members/bookings/risk': MembersEtcRiskPage,

  'members/edv/risk': MembersEtcRiskPage,
  'members/edv/checks': MembersEDVMyChecksPage,
  'members/edv/checkrequests': MembersEDVMyPendingChecksPage,
  'members/edv/checkrequest': MembersEDVRequestChecksPage,
  'members/edv/fai': MembersEDVFaiPage,
  'members/edv/flightlogs': MembersEDVFlightLogsPage,
  'members/edv/courses': MembersEDVCoursesPage,
  'members/edv/bio': MembersEDVBioPage,



  'members/equipments/addnote': MembersEquipmentsAddNotePage,
  'members/equipments/notes': MembersEquipmentsNotesPage,
  'members/equipments/state': MembersEquipmentsStatePage,
  'members/equipments/simulate': MembersEquipmentsSimulatePage,

  'user/password': UserPasswordPage,
  'user/student': UserStudentPage,
  'user/acks': UserACKPage,

  'admin/processes/default': BreadPage,
  'admin/processes/softland': AdminProcessesSoftLandPage,
  'admin/processes/pac': AdminProcessesPACPage,
  'admin/processes/installments': AdminProcessesInstallmentsPage,
  'admin/processes/charges': AdminProcessesChargesPage,

  'home': HomePage,
  'tabs': HomeTabs,
  'page404': Page404,
  'admin/bookings': AdminBookingsPage,

  'ops/mercenaries/pax': OPSMercenariesPAXPage,
  'ops/mercenaries/shifts': OPSMercenariesShiftsPage,
  'ops/fuel/movements': OPSFuelMovementsPage,
  'ops/fuel/tanks/levels': OPSFuelTanksLevelsPage,
  'ops/fuel/tanks/measure': OPSFuelTanksMeasurePage,
  'ops/fuel/tanks/addmeasure': OPSFuelTanksAddMeasurePage,
  'ops/fuel/tanks/flows': OPSFuelTanksFlowsPage,


  'ops/fuel/invoice': OPSFuelInvoicePage,
  'ops/fuel/sale': OPSFuelSaleJP1,
  'ops/fuel/prices': OPSFuelPrices,

  'ops/planning/shifts': OPSPlanningShiftsPage,
  'ops/planning/members': OPSPlanningUsersPage,
  'ops/planning/bookings': OPSPlanningBookingsPage,
  'ops/planning/book': OPSPlanningBookPage,
  'ops/planning/bookdelete': OPSPlanningBookDeletePage,
  'ops/planning/towings': OPSPlanningTowingsPage,


  'edv/checks/pending': EDVChecksPendingPage,
  'edv/checks/search': EDVChecksSearchPage,
  'edv/checks/myevals': EDVChecksMyEvalsPage,
  'edv/checks/masters': EDVCheckMasters,
  'edv/checks/mychecks': EDVChecksMyChecksPage,

  'edv/instruction/default': BreadPage,

  'edv/bio': EDVBioPage,
  'members/edv/zones': MembersEDVZonesPage,
  'members/edv/licences': MembersEDVLicencesPage,
  'edv/instruction/flightlogs': EDVInstructionFlightLogsPage,
  'edv/instruction/students': EDVInstructionStudentsPage,
  'edv/instruction/mystudents': EDVInstructionMyStudentsPage,
  'edv/annotations': EDVAnnotationsPage,


  'cma/notes/list': CMANotesListPage,
  'cma/equipments/logs': CMAEquipmentsFlightLogsPage,
  'cma/notes/answer': CMANotesAnswerPage,
  'cma/notes/add': CMANotesAddPage,
  'cma/equipments/documents': CMAEquipmentsDocumentsPage,
  'cma/equipments/state': CMAEquipmentsStatePage,
  'cma/equipments/oof': CMAEquipmentsOOFPage,

  'masters/shifts': MasterShiftsPage,
  'masters/charges': MasterCharges,
  'masters/accounts': MasterAccounts,
  'masters/groups': MasterGroups,
  'masters/groups.users': MasterGroupsUsers,
  'masters/equipments/equipment': MasterEquipmentsEquipmentPage,
  'masters/equipments/syncsm': MasterEquipmentsSyncSMPage,
  'masters/equipments/groups': MasterEquipmentsGroupsPage,
  'masters/equipments/rates': MasterEquipmentsRatesPage,
  'masters/equipments/add': MasterEquipmentsAddPage,
  'masters/equipments/categories': MasterEquipmentsCategoriesPage,
  'masters/hangars': MasterHangars,
  'masters/docs': MastersDocsPage,

  'masters/parameters/indicators': MasterParametersIndicators,
  'masters/parameters/holidays': MasterParametersHolidays,
  'masters/parameters/blockings': MasterParametersBlockings,
  'masters/users': MastersUsersPage,
  'masters/user.add': MastersUserAddPage,


  'reports/finances/finance.inout': ReportsFinanceInOutPage,
  'reports/finances/outstanding': ReportsFinanceOutstandingPage,
  'reports/finances/transfers': ReportsFinanceTransfersPage,
  'reports/finances/transfers.charges': ReportsFinanceTransfersChargesPage,
  'reports/finances/delinquency': ReportsFinancesDelinquencyPage,
  'reports/finances/duedebt': ReportsFinancesDueDebtPage,
  'reports/finances/duplicates': ReportsFinancesDuplicatesPage,
  'reports/finances/users.charges': ReportsFinancesUsersChargesPage,
  'reports/finances/rx': ReportsFinancesRXPage,
  'reports/finances/balances': ReportsFinancesBalancesPage,

  'reports/edv/default': BreadPage,
  'reports/edv/instruction': ReportsEDVInstructionPage,
  'reports/edv/towings': ReportsEDVTowingsPage,
  'reports/edv/risk': ReportsEDVRiskPage,
  'reports/edv/progress': ReportsEDVProgressPage,
  'reports/ops/fuelconsumption': ReportsOpsFuelConsumption,
  'reports/ops/fuelmovements': ReportsOpsFuelMovementsPage,
  'reports/ops/usability': ReportsOpsFuelUsabilityPage,

  'system/crons': SystemCrons,
  'system/logs': SystemLogs,
  'system/tables': SystemTables,
  'system/routing/assign': SystemRoutingAssignPage,
  'system/routing/edit': SystemRoutingEditPage,
  'system/routing/ia': SystemRoutingIAPage,
  'system/routing/order': SystemRoutingOrderPage,
  'system/routing/tester': Tester,
  'system/routing/template': Template,

  'system/emails': SystemEmails,

  'comm/news/list': CommNewsListPage,
  'comm/polls/edit': CommPollsEditPage,
  'comm/polls/enable': CommPollsEnablePage,
  'comm/polls/roll': CommPollsRollPage,
  'comm/polls/list': CommPollsPage,
  'comm/takenotes': CommTakeNotesPage,
  'comm/events/calendar': CommCalendarEventsPage,
  'comm/mailings/queue': CommMailingsQueuePage,
  'comm/mailings/create': CommMailingsCreatePage,

  'system/routing/default': BreadPage,
  'reports/ops/default': BreadPage,
  'reports/default': BreadPage,
  'comm/default': BreadPage,
  'ops/default': BreadPage,
  'edv/default': BreadPage,
  'cma/default': BreadPage,
  'admin/default': BreadPage,
  'admin/movements/pac/default': BreadPage,
  'members/default': BreadPage,
  'reports/downloads/default': BreadPage,
  'admin/movements/default': BreadPage,
  'admin/casino/default': BreadPage,
  'members/equipments/default': BreadPage,
  'members/accounts/default': BreadPage,
  'members/accounts/statements/default': BreadPage,
  'members/accounts/payments/default': BreadPage,
  'admin/rac/default': BreadPage,
  'members/bookings/default': BreadPage,
  'members/etc/default': BreadPage,
  'members/mercenaries/default': BreadPage,
  'ops/mercenaries/default': BreadPage,
  'ops/fuel/default': BreadPage,
  'ops/fuel/tanks/default': BreadPage,
  'ops/planning/default': BreadPage,
  'edv/checks/default': BreadPage,
  'cma/notes/default': BreadPage,
  'cma/equipments/default': BreadPage,
  'masters/default': BreadPage,
  'masters/equipments/default': BreadPage,
  'masters/parameters/default': BreadPage,
  'reports/finances/default': BreadPage,
  'comm/mailings/default': BreadPage,
  'comm/news/default': BreadPage,
  'comm/polls/default': BreadPage,
  'system/default': BreadPage,
  'members/etc/shifts/default': BreadPage,
  'members/edv/checks/default': BreadPage,

  'ia/data.query': IADataQueryPage,
};

function NotFound() {
  return <Error404 />;
}

interface RouterProps {
  initialPage: string;
}

// Helper functions (Improved)
function getHashPath(hash: string): string {
  const questionMarkIndex = hash.indexOf('?');
  if (questionMarkIndex !== -1) {
    return hash.substring(1, questionMarkIndex);
  }
  return hash.substring(1);
}

export function Router({ initialPage }: RouterProps) {
  const [currentPagePath, setCurrentPage] = useState(getHashPath(window.location.hash) || initialPage);
  //const { reloader, setReloader } = useGlobalState();
  const [initRouter, setInitRouter] = useState(true)



  const handleValidateStatus = useCallback(async () => {
    if (getCookie("JWT") !== "") return;
    try {
      const response = await fetch(`${getUrlVersion()}/routing/v1/?sessoin1`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/admin/admins/session',
          'JWT': getCookie("JWT"),
        },
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      if (data.code == 0) {
        if (data.UF) {
          const updatedData = { ...data, UF: Number(data.UF) };
          setData(updatedData);
        }
        if (data.counters) {
          setNotifications(data.counters)
        }
        if (data.USD) {
          const updatedData = { ...data, USD: Number(data.USD) };
          setData(updatedData);
        }
        if (data.counters) {
          const updatedData = { ...data, counters: data.counters };
          setData(updatedData);
        }
        if (data.JWT && data.JWT && data.JWT !== "") {
          if (getCookie("JWT") != data.JWTR) {
            setCookie("JWT", data.JWT);
          }
        }
      }
    } catch (error: any) {
      console.error(error);
    } finally {
      setInitRouter(false)
    }
  }, [initRouter]);

  useEffect(() => {
    const handler = () => {
      const newHash = getHashPath(window.location.hash);
      //const newReturnUrl = getHashParameter(window.location.hash, 'returnUrl');
      //setReturnUrl(newReturnUrl);
      setCurrentPage(newHash || initialPage);
    };

    window.addEventListener('hashchange', handler);
    handler(); //call handler to process initial hash

    return () => window.removeEventListener('hashchange', handler);
  }, [initialPage, setReturnUrl]);

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [currentPagePath]);

  useEffect(() => {
    let currentHash = (window.location.hash).replace("#", "") || '';

    if (!window.location.hash.startsWith("#user/")) {
      if (getCookie("JWT") === '') {
        window.location.hash = `#user/login?t=1&returnUrl=${encodeURIComponent(currentHash)}`;
        return;
      } else if (isJWTExpired(getCookie("JWT"))) {
        window.location.hash = `#user/login?t=2&returnUrl=${encodeURIComponent(currentHash)}`;
        return;
      } else {
        //handleValidateStatus();
      }
    }
  }, [currentPagePath, isJWTExpired, handleValidateStatus]);

  const CurrentPage = currentPagePath in pages ? pages[currentPagePath] : NotFound;
  return <CurrentPage />;
}

// ... (rest of your isJWTExpired and useRouter functions)
export const isJWTExpired = (token: string) => {
  if (!token) return true;
  try {
    const payloadBase64 = token.split('.')[1];
    if (!payloadBase64) return true;
    const payloadJson = atob(payloadBase64);
    const payload = JSON.parse(payloadJson);
    const now = Math.floor(Date.now() / 1000);
    return payload.exp < now;
  } catch (error) {
    console.error("Error decoding or parsing JWT:", error);
    return true;
  }
};

export function useRouter() {
  return {
    navigate: (newPage: string) => (location.hash = `#${newPage}`),
  };
}


